import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import classNames from 'classnames';
import { AccessibilityListener, normalizeInitialState, getLangDir, SPOILER_TYPE, GlobalContext, } from 'wix-rich-content-common';
import { convertToReact } from './utils/convertContentState';
import { deprecateHelpers } from 'wix-rich-content-common/dist/lib/deprecateHelpers.cjs.js';
import mergeTheme from '../../../../DaEditorWrapper/Themes/mergeTheme';
import 'wix-rich-content-common/dist/statics/styles/draftDefault.rtlignore.scss';
import viewerAlignmentStyles from 'wix-rich-content-viewer/dist/statics/rich-content-viewer-alignment.rtlignore.scss';
import viewerStyles from 'wix-rich-content-viewer/dist/statics/rich-content-viewer.scss';
import rtlStyle from 'wix-rich-content-viewer/dist/statics/rich-content-viewer-rtl.rtlignore.scss';
var RichContentViewer = /** @class */ (function (_super) {
    __extends(RichContentViewer, _super);
    function RichContentViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {};
        _this.getContextualData = function (_a, contentState) {
            var _b;
            var t = _a.t, theme = _a.theme, isMobile = _a.isMobile, anchorTarget = _a.anchorTarget, relValue = _a.relValue, config = _a.config, helpers = _a.helpers, locale = _a.locale, disabled = _a.disabled, seoMode = _a.seoMode, iframeSandboxDomain = _a.iframeSandboxDomain;
            return ({
                t: t,
                theme: theme,
                isMobile: isMobile,
                anchorTarget: anchorTarget,
                relValue: relValue,
                config: config,
                helpers: deprecateHelpers(helpers, config),
                locale: locale,
                disabled: disabled,
                seoMode: seoMode,
                contentState: contentState,
                iframeSandboxDomain: iframeSandboxDomain,
                disableRightClick: (_b = config === null || config === void 0 ? void 0 : config.uiSettings) === null || _b === void 0 ? void 0 : _b.disableRightClick,
            });
        };
        var styles = __assign(__assign(__assign({}, viewerStyles), viewerAlignmentStyles), rtlStyle);
        _this.styles = mergeTheme(styles, props.theme);
        _this.state = {
            raw: {},
        };
        return _this;
    }
    RichContentViewer.getDerivedStateFromProps = function (props) {
        return {
            raw: RichContentViewer.getInitialState(props),
        };
    };
    RichContentViewer.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    RichContentViewer.prototype.render = function () {
        var _a, _b;
        var _c;
        var _d = this.props, onError = _d.onError, _e = _d.config, config = _e === void 0 ? {} : _e;
        try {
            if (this.state.error) {
                onError(this.state.error);
                return null;
            }
            var styles = this.styles;
            var _f = this.props, textDirection = _f.textDirection, typeMappers = _f.typeMappers, decorators = _f.decorators, inlineStyleMappers = _f.inlineStyleMappers, locale = _f.locale, addAnchors = _f.addAnchors, isMobile = _f.isMobile, t = _f.t;
            var wrapperClassName = classNames(styles.wrapper, (_a = {},
                _a[styles.desktop] = !this.props.platform || this.props.platform === 'desktop',
                _a));
            var editorClassName = classNames(styles.editor, (_b = {},
                _b[styles.rtl] = textDirection === 'rtl',
                _b));
            var initSpoilers = (_c = config[SPOILER_TYPE]) === null || _c === void 0 ? void 0 : _c.initSpoilersContentState;
            // @ts-ignore
            var contextualData = this.getContextualData(this.props, this.state.raw);
            var output = convertToReact(styles, textDirection, typeMappers, contextualData, decorators, inlineStyleMappers, initSpoilers, { addAnchors: addAnchors });
            return (React.createElement(GlobalContext.Provider, { value: { isMobile: isMobile, t: t } },
                React.createElement("div", { className: wrapperClassName, dir: getLangDir(locale) },
                    React.createElement("div", { className: editorClassName }, output),
                    React.createElement(AccessibilityListener, { isMobile: this.props.isMobile }))));
        }
        catch (err) {
            onError(err);
            return null;
        }
    };
    RichContentViewer.getInitialState = function (props) {
        var initialState = props.initialState, anchorTarget = props.anchorTarget, relValue = props.relValue, _a = props.normalize, _b = _a.disableInlineImages, disableInlineImages = _b === void 0 ? false : _b, _c = _a.removeInvalidInlinePlugins, removeInvalidInlinePlugins = _c === void 0 ? false : _c;
        return initialState
            ? normalizeInitialState(initialState, {
                anchorTarget: anchorTarget,
                relValue: relValue,
                disableInlineImages: disableInlineImages,
                removeInvalidInlinePlugins: removeInvalidInlinePlugins,
            })
            : {};
    };
    return RichContentViewer;
}(Component));
// @ts-ignore
RichContentViewer.defaultProps = {
    theme: {},
    decorators: [],
    typeMappers: [],
    inlineStyleMappers: [],
    locale: 'en',
    onError: function (err) {
        throw err;
    },
    normalize: {},
};
export default RichContentViewer;
//# sourceMappingURL=RichContentViewer.js.map